export default "__VITE_ASSET__BaUetHV9__"